export const CALC_OPTIONS = 'CALC_OPTIONS'
export const BOOKING = 'BOOKING'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const GET_REQUESTS = 'GET_REQUESTS'
export const GET_VOLUNTEERS = 'GET_VOLUNTEERS'
export const PAYMENT_SUCCEED = 'PAYMENT_SUCCEED'
